import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, QueryList, ChangeDetectorRef, ViewChildren, ContentChildren } from '@angular/core';
import { __decorate, __metadata } from 'tslib';
import { NgFor } from '@angular/common';
import { tabFadeAnimation } from '@ng-doc/ui-kit/animations';
import { NgDocSelectionHostDirective, NgDocSelectionComponent, NgDocSelectionOriginDirective } from '@ng-doc/ui-kit/components/selection';
import { NgDocSmoothResizeComponent } from '@ng-doc/ui-kit/components/smooth-resize';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import * as i1 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { startWith } from 'rxjs/operators';
const _c0 = ["headerTab"];
const _c1 = () => ({});
function NgDocTabGroupComponent_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const tab_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(tab_r2.label);
  }
}
function NgDocTabGroupComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6, 0);
    i0.ɵɵlistener("click", function NgDocTabGroupComponent_div_2_Template_div_click_0_listener() {
      const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectTab(tab_r2));
    });
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtemplate(3, NgDocTabGroupComponent_div_2_ng_container_3_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", tab_r2 === ctx_r2.selectedTab);
    i0.ɵɵproperty("ngDocSelectionOrigin", tab_r2 === ctx_r2.selectedTab);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("polymorpheusOutlet", tab_r2.label)("polymorpheusOutletContext", i0.ɵɵpureFunction0(5, _c1));
  }
}
function NgDocTabGroupComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const text_r4 = ctx.polymorpheusOutlet;
    i0.ɵɵproperty("@tabFadeAnimation", undefined);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r4, " ");
  }
}
let NgDocTabComponent = /*#__PURE__*/(() => {
  class NgDocTabComponent {
    constructor() {
      this.label = '';
      this.id = 0;
      /** Expander content */
      this.content = '';
    }
    static {
      this.ɵfac = function NgDocTabComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocTabComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocTabComponent,
        selectors: [["ng-doc-tab"], ["a", "ng-doc-tab", ""]],
        inputs: {
          label: "label",
          id: "id",
          content: "content"
        },
        decls: 0,
        vars: 0,
        template: function NgDocTabComponent_Template(rf, ctx) {},
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NgDocTabComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgDocTabGroupComponent = /*#__PURE__*/(() => {
  let NgDocTabGroupComponent = class NgDocTabGroupComponent {
    constructor(changeDetectorRef) {
      this.changeDetectorRef = changeDetectorRef;
      this.tabElements = new QueryList();
      this.tabs = new QueryList();
    }
    ngAfterContentInit() {
      this.tabs.changes.pipe(startWith(this.tabs), untilDestroyed(this)).subscribe(() => {
        const tabToOpen = this.openedTab ? this.tabs.find(tab => tab.id === this.openedTab) : this.tabs.get(0);
        tabToOpen && this.selectTab(tabToOpen);
        this.changeDetectorRef.markForCheck();
      });
    }
    ngAfterViewInit() {
      this.tabElements.changes.pipe(startWith(this.tabElements), untilDestroyed(this)).subscribe(() => this.changeDetectorRef.detectChanges());
    }
    get selectedIndex() {
      return this.selectedTab ? this.tabs.toArray().indexOf(this.selectedTab) : -1;
    }
    get selectedHeaderTab() {
      return this.selectedTab ? this.tabElements.get(this.selectedIndex) ?? null : null;
    }
    selectTab(tab) {
      this.selectedTab = tab;
    }
    static {
      this.ɵfac = function NgDocTabGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocTabGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocTabGroupComponent,
        selectors: [["ng-doc-tab-group"]],
        contentQueries: function NgDocTabGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, NgDocTabComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabs = _t);
          }
        },
        viewQuery: function NgDocTabGroupComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabElements = _t);
          }
        },
        inputs: {
          openedTab: "openedTab"
        },
        decls: 6,
        vars: 5,
        consts: [["headerTab", ""], ["ngDocSelectionHost", "", 1, "ng-doc-tabs-wrapper"], ["class", "ng-doc-tab", 3, "selected", "ngDocSelectionOrigin", "click", 4, "ngFor", "ngForOf"], [1, "ng-doc-body-wrapper"], [3, "trigger"], [4, "polymorpheusOutlet", "polymorpheusOutletContext"], [1, "ng-doc-tab", 3, "click", "ngDocSelectionOrigin"], [1, "ng-doc-tab-text"]],
        template: function NgDocTabGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵelement(1, "ng-doc-selection");
            i0.ɵɵtemplate(2, NgDocTabGroupComponent_div_2_Template, 4, 6, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "ng-doc-smooth-resize", 4);
            i0.ɵɵtemplate(5, NgDocTabGroupComponent_div_5_Template, 2, 2, "div", 5);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_1_0;
            let tmp_2_0;
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.tabs);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("trigger", (tmp_1_0 = ctx.selectedTab == null ? null : ctx.selectedTab.content) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("polymorpheusOutlet", (tmp_2_0 = ctx.selectedTab == null ? null : ctx.selectedTab.content) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "")("polymorpheusOutletContext", i0.ɵɵpureFunction0(4, _c1));
          }
        },
        dependencies: [NgDocSelectionHostDirective, NgDocSelectionComponent, NgFor, NgDocSelectionOriginDirective, PolymorpheusModule, i1.PolymorpheusOutletDirective, NgDocSmoothResizeComponent],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;background:var(--ng-doc-tab-group-header-background, var(--ng-doc-tab-group-background));border-radius:var(--ng-doc-tab-group-border-radius);border:var(--ng-doc-tab-group-border);overflow:hidden}[_nghost-%COMP%]   .ng-doc-tabs-wrapper[_ngcontent-%COMP%]{font-family:var(--ng-doc-font-family);font-variant:no-contextual;color:var(--ng-doc-text);line-height:var(--ng-doc-line-height);font-size:var(--ng-doc-font-size);font-weight:var(--ng-doc-font-weight);position:relative;width:100%;display:inline-flex;overflow-x:auto;line-height:18px;font-size:14px;flex-shrink:0;background:var(--ng-doc-tab-group-tabs-background)}[_nghost-%COMP%]   .ng-doc-tabs-wrapper[_ngcontent-%COMP%]   .ng-doc-tab[_ngcontent-%COMP%]{position:relative;padding:var(--ng-doc-base-gutter) calc(var(--ng-doc-base-gutter) * 2);cursor:pointer;white-space:nowrap}[_nghost-%COMP%]   .ng-doc-tabs-wrapper[_ngcontent-%COMP%]   .ng-doc-tab[_ngcontent-%COMP%]   .ng-doc-tab-text[_ngcontent-%COMP%]{font-family:var(--ng-doc-font-family);font-variant:no-contextual;color:var(--ng-doc-text);line-height:var(--ng-doc-line-height);font-size:var(--ng-doc-font-size);font-weight:var(--ng-doc-font-weight);position:relative;--ng-doc-font-size: 13px;--ng-doc-font-weight: 500}[_nghost-%COMP%]   .ng-doc-body-wrapper[_ngcontent-%COMP%]{position:relative;background-color:var(--ng-doc-tab-group-background);height:100%;overflow:hidden;border-top:1px solid var(--ng-doc-border-color)}"],
        data: {
          animation: [tabFadeAnimation]
        },
        changeDetection: 0
      });
    }
  };
  NgDocTabGroupComponent = __decorate([UntilDestroy(), __metadata("design:paramtypes", [ChangeDetectorRef])], NgDocTabGroupComponent);
  return NgDocTabGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocTabComponent, NgDocTabGroupComponent };
